/**
 * Servicio de Encuestas Express
 * Maneja todas las llamadas API relacionadas con encuestas anónimas
 */
import api from './api';

/**
 * Obtiene el listado de encuestas disponibles para Plaza Express
 * @returns {Promise<Array>} Lista de encuestas
 */
export const getEncuestas = async () => {
  try {
    const response = await api.get('/express/encuestas');
    return response.data;
  } catch (error) {
    console.error('Error al obtener encuestas:', error);
    throw error;
  }
};

/**
 * Obtiene una encuesta completa por ID
 * @param {number} idEncuesta - ID de la encuesta
 * @param {string} fingerprintHash - Hash del fingerprint
 * @param {string} cookieToken - Token de cookie
 * @returns {Promise<Object>} Encuesta completa con preguntas
 */
export const getEncuesta = async (idEncuesta, fingerprintHash = null, cookieToken = null) => {
  try {
    const params = {};
    if (fingerprintHash) params.fingerprint_hash = fingerprintHash;
    if (cookieToken) params.cookie_token = cookieToken;
    
    const response = await api.get(`/express/encuestas/${idEncuesta}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener encuesta:', error);
    throw error;
  }
};

/**
 * Verifica el estado de voto de un usuario
 * @param {number} idEncuesta - ID de la encuesta
 * @param {string} fingerprintHash - Hash del fingerprint
 * @param {string} cookieToken - Token de cookie
 * @returns {Promise<Object>} Estado del voto {ya_participo, puede_votar}
 */
export const verificarEstadoVoto = async (idEncuesta, fingerprintHash, cookieToken) => {
  try {
    const params = {
      fingerprint_hash: fingerprintHash,
      cookie_token: cookieToken,
    };
    
    const response = await api.get(`/express/encuestas/${idEncuesta}/estado`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al verificar estado de voto:', error);
    throw error;
  }
};

/**
 * Registra un voto anónimo en una encuesta
 * @param {number} idEncuesta - ID de la encuesta
 * @param {Object} datosVoto - Datos del voto
 * @param {string} datosVoto.fingerprint_hash - Hash del fingerprint
 * @param {string} datosVoto.cookie_token - Token de cookie
 * @param {string} datosVoto.recaptcha_token - Token de reCAPTCHA
 * @param {Array} datosVoto.respuestas - Array de respuestas
 * @param {Object} datosVoto.datos_demograficos - Datos demográficos opcionales
 * @param {number} datosVoto.tiempo_total - Tiempo total en segundos
 * @returns {Promise<Object>} Resultado del voto
 */
export const votarEncuesta = async (idEncuesta, datosVoto) => {
  try {
    const response = await api.post(`/express/encuestas/${idEncuesta}/votar`, datosVoto);
    return response.data;
  } catch (error) {
    console.error('Error al votar encuesta:', error);
    throw error;
  }
};

